import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.clubUser}/v4/dashboard`, {
  get: {
    'dashboard.users.information': '/users/information'
  }
});

Request.register(`${Settings.api.display}`, {
  get: {
    'has.newClub': '/memberships/products/:productId'
  }
});

Request.register(`${Settings.api.eligibleProducts}`, {
  get: {
    'eligible.products': '/admin/memberships/products/eligible?page=1&size=1000'
  }
});
